import React from 'react';
import { Location } from 'history';

import { Box } from '@rover/kibble/core';
import type { EnhancedPersonSitterProfile } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfile';

import { useRevampProfileContext } from '../../hooks/useRevampProfileContext';

import DesktopProfileHeader from './DesktopProfileHeader';
import MobileProfileHeader from './MobileProfileHeader';

const MOBILE_TABLET_DISPLAY = ['flex', 'flex', 'none'];
const DESKTOP_ONLY_DISPLAY = ['none', 'none', 'flex'];

export type ProfileHeaderProps = {
  sitterInfo: EnhancedPersonSitterProfile;
  sitterImage: string;
  ownProfile: boolean;
  isApproved: boolean;
  isUnderReview: boolean;
  onAvatarClick: (index: number) => void;
  onError: (error: string) => void;
  location: Location;
  service?: string;
  serviceType?: string;
  searchParams: URLSearchParams;
  isLoggedIn?: boolean;
  isInLaunchedCountry: boolean;
  contactUrl: string;
  sitterSlug: string;
  shouldShowPromoteProfileButton?: boolean;
};

const RevampProfileHeader = ({
  sitterInfo,
  sitterImage,
  ownProfile,
  isApproved,
  isUnderReview,
  onAvatarClick,
  onError,
  location,
  service,
  serviceType,
  searchParams,
  isLoggedIn,
  isInLaunchedCountry,
  contactUrl,
  sitterSlug,
  shouldShowPromoteProfileButton,
}: ProfileHeaderProps): JSX.Element => {
  const { setReviewsModalOpen } = useRevampProfileContext();
  const handleReviewsCountPress = (): void => setReviewsModalOpen(true);

  return (
    <>
      <Box display={MOBILE_TABLET_DISPLAY} width="100%">
        <MobileProfileHeader
          sitterInfo={sitterInfo}
          sitterImage={sitterImage}
          ownProfile={ownProfile}
          isApproved={isApproved}
          onAvatarClick={onAvatarClick}
          onError={onError}
          location={location}
          service={service}
          searchParams={searchParams}
          isLoggedIn={isLoggedIn}
          onReviewsCountPress={handleReviewsCountPress}
        />
      </Box>
      <Box display={DESKTOP_ONLY_DISPLAY} width="100%">
        <DesktopProfileHeader
          sitterInfo={sitterInfo}
          sitterImage={sitterImage}
          ownProfile={ownProfile}
          isApproved={isApproved}
          isUnderReview={isUnderReview}
          onAvatarClick={onAvatarClick}
          onError={onError}
          location={location}
          service={service}
          serviceType={serviceType}
          searchParams={searchParams}
          isLoggedIn={isLoggedIn}
          isInLaunchedCountry={isInLaunchedCountry}
          contactUrl={contactUrl}
          sitterSlug={sitterSlug}
          shouldShowPromoteProfileButton={shouldShowPromoteProfileButton}
          onReviewsCountPress={handleReviewsCountPress}
        />
      </Box>
    </>
  );
};

export default RevampProfileHeader;
